/**
 * Coming-soon waitlist form — POSTs to Google Apps Script Web App.
 *
 * Uses mode: "no-cors" (required for this endpoint). The response is always opaque:
 * response.ok is false and response.status is 0 even on success — never check them.
 */
(function () {
  var form = document.querySelector(".arcanist-password__form");
  if (!form) return;

  var endpoint = form.getAttribute("data-endpoint");
  var successMessage = form.getAttribute("data-success-message") || "Your response has been submitted";
  var errorMessage = form.getAttribute("data-error-message") || "Something went wrong. Please check your details and try again.";
  var panel = form.closest(".arcanist-password__form-panel");

  var emailFormatPattern =
    /^[^\s@]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,62}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,62}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;

  var emailPlaceholderTerms = ["test", "fake", "example", "demo", "asdf", "xxx", "noemail", "notreal", "sample"];
  var blockedEmailDomains = [
    "example.com",
    "test.com",
    "fake.com",
    "mailinator.com",
    "tempmail.com",
    "guerrillamail.com",
    "10minutemail.com",
    "yopmail.com",
    "throwawaymail.com",
    "trashmail.com",
  ];
  var fakePhoneSequences = ["1234567890", "0123456789", "9876543210", "0987654321"];

  function showMessage(type, text) {
    if (!panel) return;
    panel.replaceChildren();
    var message = document.createElement("p");
    message.className = "arcanist-password__message arcanist-password__message--" + type;
    message.tabIndex = -1;
    message.textContent = text;
    panel.appendChild(message);
    message.focus();
  }

  function clearFieldErrors() {
    form.querySelectorAll(".arcanist-password__field-error").forEach(function (el) {
      el.remove();
    });
    form.querySelectorAll(".arcanist-password__input--invalid").forEach(function (el) {
      el.classList.remove("arcanist-password__input--invalid");
      el.removeAttribute("aria-invalid");
    });
  }

  function showFieldError(input, message) {
    if (!input) return;
    var field = input.closest(".arcanist-password__field");
    if (!field) return;

    input.classList.add("arcanist-password__input--invalid");
    input.setAttribute("aria-invalid", "true");

    var err = document.createElement("p");
    err.className = "arcanist-password__field-error";
    err.id = input.id + "-error";
    err.textContent = message;
    input.setAttribute("aria-describedby", err.id);
    field.appendChild(err);
  }

  function validateEmail(email) {
    if (!email || !emailFormatPattern.test(email)) {
      return "Please enter a valid email";
    }

    var parts = email.toLowerCase().split("@");
    if (parts.length !== 2) return "Please enter a valid email";

    var local = parts[0];
    var domain = parts[1];

    for (var i = 0; i < emailPlaceholderTerms.length; i++) {
      if (local.indexOf(emailPlaceholderTerms[i]) !== -1) {
        return "Please enter a valid email";
      }
    }

    for (var j = 0; j < blockedEmailDomains.length; j++) {
      if (domain === blockedEmailDomains[j]) {
        return "Please enter a valid email";
      }
    }

    return null;
  }

  function phoneDigits(phone) {
    return phone.replace(/\D/g, "");
  }

  function isRepeatedDigits(digits) {
    return digits.length >= 10 && /^(\d)\1+$/.test(digits);
  }

  function isSequentialDigits(digits) {
    if (digits.length < 10) return false;
    var segment = digits.length === 10 ? digits : digits.slice(-10);
    return fakePhoneSequences.indexOf(segment) !== -1;
  }

  function validatePhone(phone) {
    var digits = phoneDigits(phone);
    if (digits.length < 10) {
      return "Please enter a valid phone number";
    }
    if (isRepeatedDigits(digits.length === 10 ? digits : digits.slice(-10))) {
      return "Please enter a valid phone number";
    }
    if (isSequentialDigits(digits)) {
      return "Please enter a valid phone number";
    }
    return null;
  }

  function validate() {
    var honeypot = form.querySelector('[name="website"]');
    if (honeypot && honeypot.value.trim()) return { honeypot: true };

    var nameInput = form.querySelector('[name="name"]');
    var emailInput = form.querySelector('[name="email"]');
    var phoneInput = form.querySelector('[name="phone"]');

    var name = nameInput ? nameInput.value.trim() : "";
    var email = emailInput ? emailInput.value.trim() : "";
    var phone = phoneInput ? phoneInput.value.trim() : "";

    var fieldErrors = {};

    if (!name) {
      fieldErrors.name = "Please enter your name.";
    }

    var emailError = validateEmail(email);
    if (emailError) fieldErrors.email = emailError;

    var phoneError = validatePhone(phone);
    if (phoneError) fieldErrors.phone = phoneError;

    if (Object.keys(fieldErrors).length) {
      return { fieldErrors: fieldErrors };
    }

    return {
      payload: {
        name: name,
        email: email,
        phone: phone,
      },
    };
  }

  form.querySelectorAll(".arcanist-password__input").forEach(function (input) {
    input.addEventListener("input", function () {
      input.classList.remove("arcanist-password__input--invalid");
      input.removeAttribute("aria-invalid");
      input.removeAttribute("aria-describedby");
      var field = input.closest(".arcanist-password__field");
      if (field) {
        var err = field.querySelector(".arcanist-password__field-error");
        if (err) err.remove();
      }
    });
  });

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    clearFieldErrors();

    if (!endpoint) {
      showMessage("error", errorMessage);
      return;
    }

    var result = validate();
    if (result.honeypot) {
      showMessage("success", successMessage);
      return;
    }

    if (result.fieldErrors) {
      var nameInput = form.querySelector('[name="name"]');
      var emailInput = form.querySelector('[name="email"]');
      var phoneInput = form.querySelector('[name="phone"]');

      if (result.fieldErrors.name) showFieldError(nameInput, result.fieldErrors.name);
      if (result.fieldErrors.email) showFieldError(emailInput, result.fieldErrors.email);
      if (result.fieldErrors.phone) showFieldError(phoneInput, result.fieldErrors.phone);

      var firstInvalid =
        (result.fieldErrors.name && nameInput) ||
        (result.fieldErrors.email && emailInput) ||
        (result.fieldErrors.phone && phoneInput);
      if (firstInvalid) firstInvalid.focus();
      return;
    }

    var submitButton = form.querySelector('[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    try {
      sessionStorage.setItem("arcanist-skip-password-loader", "1");
    } catch (e) {}

    fetch(endpoint, {
      method: "POST",
      mode: "no-cors",
      body: new URLSearchParams(result.payload),
    })
      .then(function () {
        showMessage("success", successMessage);
      })
      .catch(function () {
        if (submitButton) submitButton.disabled = false;
        showMessage("error", errorMessage);
      });
  });
})();
